import { Component, Input, Output, OnInit, OnDestroy, AfterViewInit, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { Observable, ReplaySubject, Subscription } from 'rxjs/';

import { UtilService } from '../../../core/services/util.service';

declare var $: any;

@Component({
    selector: 'itpx-dynamic-dropdown',
    templateUrl: './dynamic-dropdown.component.html',
    styleUrls: ['./dynamic-dropdown.component.css']
})
export class DynamicDropdownComponent {

}


// WEBPACK FOOTER //
// ./src/app/shared/components/dynamic-dropdown/dynamic-dropdown.component.ts